import { render, staticRenderFns } from "./RoleWindow.vue?vue&type=template&id=c4328722&scoped=true"
import script from "./RoleWindow.vue?vue&type=script&lang=js"
export * from "./RoleWindow.vue?vue&type=script&lang=js"
import style0 from "./RoleWindow.vue?vue&type=style&index=0&id=c4328722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4328722",
  null
  
)

export default component.exports